import { FC, CSSProperties } from 'react';

interface LogoProps {
    color?: string;
    className?: string;
    style?: CSSProperties;
    width?: number | string;
    height?: number | string;
}

const Logo: FC<LogoProps> = ({ color = 'currentColor', className, style, width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 476.95 192.6"
        fill={color}
        className={className}
        style={style}
        width={width}
        height={height}
        aria-hidden="true"
    >
        <path
            fillRule="evenodd"
            d="M246.29,8.08v9.44c-4.53,0-7.27,1.23-8.31,3.78A14.34,14.34,0,0,0,236.85,27h9.44v9.45H222.77V27h4.63a23,23,0,0,1,1-7.55c1.51-3.78,3.5-6.52,5.86-8.12,3.11-2.18,7.08-3.21,12-3.21Zm27.39,66.11H182.54v-14c0-7.27.76-12.94,2.08-17A35.13,35.13,0,0,1,187.55,37a19.6,19.6,0,0,1,4.72-5.58,22.56,22.56,0,0,1,7.08-3.68,29.57,29.57,0,0,1,9.92-1.51L214,40.09q-8.64,0-11.62,5.39a17.28,17.28,0,0,0-2.26,7.08,63,63,0,0,0-.38,7.74h56.76V8.08h17.19V60.3h43.64V8.08H334.5V74.19Zm87.46,0H344V8.08h17.19V60.3h65.54V26.21H444c16.65,0,28.54,6.52,29.28,24.18.09,2.26.19,5.57.19,9.91V74.19ZM443.87,60.3h12.38c0-7.36-.19-11.61-.48-12.84-1.7-6.81-5.19-7.37-11.9-7.37V60.3ZM251,153.7H236.05l-1.88-34.83-10.36,35.18h-11.7l-11.69-35-1.34,34.65H183.45l3-62.51h17.77l13.39,41.61,12.41-41.61h17.41L251,153.7Zm28.21-23.58h12.59l-6.34-21.07-6.25,21.07ZM316,153.7H299.17l-3.84-10.45H275.51l-3.84,10.45H255.06l22.59-62.51h15.81L316,153.7Zm21.88-13.13h26.34V153.7h-42.6V91.19h16.26v49.38Zm76.61-36.25h-26v11.52h21.08V129H388.46v11.61h27.86V153.7H372.21V91.19h42.24v13.13Zm31.43,24.37h-4.82v25H424.8V91.28h16.26v24.29h4a5.93,5.93,0,0,0,3.4-1,9.27,9.27,0,0,0,2.41-4l7.05-19.29h17.68l-9.29,21.52c-1.69,3.93-4.1,6.43-7.23,7.41,3.4,1.43,5.89,4.29,7.5,8.57L477,153.7H459.09l-6.25-17.24a19.06,19.06,0,0,0-2.95-6,4.76,4.76,0,0,0-4-1.79ZM0,4.5V154.6a4.5,4.5,0,0,0,4.49,4.49H98.16V75L81,86.21,63.78,75v58L38.2,117.68V27.82L81,55.7,123.7,27.85c0,48.26,0,116.49,0,164.75l7.52-13.53H154.6a4.5,4.5,0,0,0,4.5-4.49V4.5A4.5,4.5,0,0,0,154.6,0H4.5A4.5,4.5,0,0,0,0,4.5Z"
        />
    </svg>
);

export default Logo;
